import cn from 'classnames';
import { useEffect, useState } from 'react';
import useRandomInterval from '../../hooks/useRandomInterval';
import { LOCALE } from '../../constants';

const RandomNumber = ({ number, slow }) => {
  const fontSize = 39;
  const elementStyle = {
    transform: `translateY(-${(number - 1) * fontSize}px)`
  }

  return (
    <span style={elementStyle} className={cn('number-animator__animated', { 'number-animator__animated--slow': slow })}>1 2 3 4 5 6 7 8 9 0</span>
  );
};

const NUMBER_SEPARATOR = LOCALE === 'de' ? '.' : ',';

export default function NumberAnimator({ number }) {
  const [initialNumber] = useState((+number + Math.floor(Math.random() * 1000)).toString())
  const [displayNumber, setDisplayNumber] = useState(initialNumber || '0');
  const [isPending, setIsPending] = useState(true);
  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => setIsPending(false), 700)

    return () => clearTimeout(timeout)
  }, [])

  useEffect(() => {
    if (displayNumber.length < initialNumber.toString().length) {
      const duration = displayNumber.length === 0 ? 1000 : 250;
      const timeout = setTimeout(() => {
        setDisplayNumber(
          initialNumber
            .toString()
            .slice(
              initialNumber.length - displayNumber.length - 1,
              initialNumber.length
            )
        );
      }, duration);

      return () => clearTimeout(timeout);
    } else {
      setIsFirstRender(false);
    }
  }, [displayNumber, initialNumber]);

  useRandomInterval(() => {
    const modifier = Math.random() < 0.5
      ? - Math.floor(Math.random() * 200)
      : Math.floor(Math.random() * 200);
    const newNumber = +displayNumber + modifier;

    setDisplayNumber(newNumber.toString());
  }, 1500, 3000, isFirstRender)

  const formatString = (str) => {
    return str
      .split("")
      .reverse()
      .join("")
      .replace(/\d{3}(?=\d)/g, `$&${NUMBER_SEPARATOR}`)
      .split("")
      .reverse()
      .join("");
  };

  const formattedString = formatString(displayNumber);

  if (!displayNumber) {
    return 0
  }

  if (isPending) {
    if (formattedString) {
      return (
        <>
          {formattedString.split("").map((element, index) => {
            if (element === NUMBER_SEPARATOR) {
              return <span key={index}>{element}</span>;
            }

            return (
              <span key={index} className="number-animator__animated">{element}</span>
            );
          })}
        </>
      );
    }
    return (
      <span>{formattedString || '0'}</span>
    )
  }

  return (
    <>
      {formattedString.split("").map((element, index) => {
        if (element === NUMBER_SEPARATOR) {
          return <span key={index}>{element}</span>;
        }

        return (
          <RandomNumber slow={!isFirstRender} key={index} number={element} />
        );
      })}
    </>
  );
}
